<template>
   <div class="upload" :style="{width:(width || '95') + 'px',height:(height || '95') + 'px'}">
       <img :src="img" class="img" alt="">
       <input type="file" accept="image/*" @change="uploadImage" name="uploader-input" class="uploader-input">
   </div>
</template>

<script>
export default {
    props:['width','height','img'],
   data (){
       return {
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       uploadImage(event){
        //    console.log(event);
            let file = event.target.files[0];
            let param = new FormData();
            param.append('file', file);
            this.$post('UploadImage',param)
                .then(data => {
                    this.$emit('imgUpload',data);
                }, error => {
                    this.$message.error(error);
                });
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.upload{
    position: relative;
    .img{
        width:100%;
        height:100%;
    }
    .uploader-input{
        width:100%;
        height: 100%;
        background: red;
        position:absolute;
        top:0;
        left:0;
        cursor: pointer;
        opacity: 0;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/uplaodImage.vue